import Highcharts from 'highcharts';
Highcharts.setOptions({
	lang: {
		      decimalPoint: ','
	      }
});
export const figure71 = {
  chart: {
    zoomType: 'xy',
    animation: false,
    marginTop: 50,
    plotBackgroundColor: null,
    plotBorderWidth: null,
    plotShadow: false,
    type: 'bar',
    backgroundColor: 'rgba(255, 255, 255, 0.0)',
    style: {
      fontFamily: 'Montserrat'
    }
  },

  colors: ['#5b9bd5'],

  credits: {
    enabled: false
  },
  title: {
    text: null
  },
  subtitle: {
    text: null
  },

  plotOptions: {
    series: {
      borderWidth: 0,
      marker: {
        symbol: 'circle',
        enabled: false,
        states: {
          hover: {
            enabled: true,
            radius: 5
          }
        }
      }
    }
  },

  exporting: {
    enabled: false
  },


  xAxis: [{
    categories: [
		 'Monde',
		 'Amérique du Nord et Europe',
		 'Asie de l’Est et du Sud-Est',
		 'Asie centrale et du Sud',
		 'Océanie hors Australie et Nouvelle-Zélande',
		 'Asie de l’Ouest et Afrique du Nord',
		 'Amérique latine et Caraïbes',
		 'Afrique subsaharienne',
		 'Australie et Nouvelle-Zélande',
    ],
    lineColor: "#d7d7d7",
    tickColor: "#d7d7d7",
    tickLength: 16,
    labels: {

      style: {
        fontWeight: 'normal',
        color: '#999999',
        fontSize: '12px'
      }
    },
  }],
  yAxis: [{ // Primary yAxis
    labels: {
      format: '{value}',
      style: {
        fontWeight: 'normal',
        color: '#999999',
        fontSize: '12px'
      },
    },
    gridLineWidth: 2,
    max: 100,
    min: 0,
    tickInterval: 20,
    title: {
      text: null,
      style: {
        color: Highcharts.getOptions().colors[1]
      }
    }
  }],
  tooltip: {
    shared: true,
    useHTML: true,
    hideDelay: 500,
    backgroundColor: null,
    borderWidth: 0,
    shadow: false,
    style: {
      padding: 0
    }
  },
  legend: {
    enabled: false,
  },

  series: [{
    name: '',
    tooltip: {
      valueSuffix: '%'
    },
    dataLabels: {
      enabled: true,
      style: {
        fontWeight: 'normal',
        textOutline: false,
        color: '#999999',
        fontSize: '12px'
      }

    },
    data: [
        {y: 73, color: '#ed7d31'},
        {y: 66, color: '#5b9bd5'},
        {y: 85, color: '#5b9bd5'},
        {y: 66, color: '#5b9bd5'},
        {y: 99, color: '#5b9bd5'},
        {y: 55, color: '#5b9bd5'},
        {y: 81, color: '#5b9bd5'},
        {y: 92, color: '#5b9bd5'},
        {y: 94, color: '#5b9bd5'}
    ]
  }]

}

